import type { AppUser } from '@/types/admin.types';

export interface AdminUser extends AppUser {
  ouId?: string;
  alcance: string;
  canCreateSurveys: boolean;
  canViewAnalytics: boolean;
  canManageUsers: boolean;
  canApproveSurveys: boolean;
  active: boolean;
}

export const MOCK_USERS: AdminUser[] = [
  { id: '1', name: 'Usuario Demo 1',  email: 'admin.central@example.com',  roleKey: 'admin.roleAdminCentral', ou: 'Todas',  alcance: 'Global', canCreateSurveys: true,  canViewAnalytics: true,  canManageUsers: true,  canApproveSurveys: true,  active: true  },
  { id: '2', name: 'Usuario Demo 2',  email: 'admin.mexico@example.com',   roleKey: 'admin.roleAdminOU',      ou: 'México', alcance: 'México', canCreateSurveys: false, canViewAnalytics: true,  canManageUsers: false, canApproveSurveys: false, active: true  },
  { id: '3', name: 'Usuario Demo 3',  email: 'admin.europa@example.com',   roleKey: 'admin.roleAdminOU',      ou: 'Europa', alcance: 'Europa', canCreateSurveys: false, canViewAnalytics: false, canManageUsers: false, canApproveSurveys: false, active: false },
  { id: '4', name: 'Usuario Demo 4',  email: 'admin.latam@example.com',    roleKey: 'admin.roleAdminOU',      ou: 'LATAM',  alcance: 'LATAM',  canCreateSurveys: true,  canViewAnalytics: true,  canManageUsers: false, canApproveSurveys: true,  active: true  },
  { id: '5', name: 'Usuario Demo 5',  email: 'admin.usa@example.com',      roleKey: 'admin.roleAdminOU',      ou: 'USA',    alcance: 'USA',    canCreateSurveys: false, canViewAnalytics: true,  canManageUsers: false, canApproveSurveys: false, active: true  },
  { id: '6', name: 'Usuario Demo 6',  email: 'admin.global@example.com',   roleKey: 'admin.roleAdminCentral', ou: 'Todas',  alcance: 'Global', canCreateSurveys: true,  canViewAnalytics: true,  canManageUsers: true,  canApproveSurveys: true,  active: true  },
];

export const ROLE_CSS_CLASS: Record<string, string> = {
  'admin.roleAdminCentral': 'admin-central',
  'admin.roleAdminOU':      'admin-ou',
  'admin.roleEmployee':     'empleado',
};
